import { render, staticRenderFns } from "./TheElectionImportModal.vue?vue&type=template&id=494dfee9&"
import script from "./TheElectionImportModal.vue?vue&type=script&lang=js&"
export * from "./TheElectionImportModal.vue?vue&type=script&lang=js&"
import style0 from "./TheElectionImportModal.vue?vue&type=style&index=0&id=494dfee9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports